import React, { useState, useEffect } from 'react';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import Link from '../../Link/Link';
import CustomPagination from '../../CustomPagination/CustomPagination';
import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';
import Loader from '../../Common/Loader/Loader';

import deleteUser from '../../../actions/siteadmin/Users/deleteUser';
import debounce from '../../../helpers/debounce';
import messages from '../../../locale/messages';
import { editUser } from '../../../actions/siteadmin/Users/editUser';
import getCurrentPage from '../../../helpers/getCurrentPage';
import { demoRestriction, demoRestrictionEncode } from '../../../actions/demoRestriction';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { censorEmail, censorPhone, censorWord, decode } from '../../../helpers/queryEncryption';

import { CommonAdminEditIcon, CommonAdminTrashIcon, ExportCsvIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './UserList.css';

const UsersList = (props) => {
  const {
    userDetails,
    userDetails: { getAllUsers, loading, refetch },
    currency,
    base,
    deleteUser,
    editUser,
    intl: { formatMessage },
    demoRestriction, demoRestrictionEncode
  } = props;

  const [state, setState] = useState({
    currentPage: 1,
    searchList: ''
  });

  const [isRestrict, setRestrict] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const isRestrict = await demoRestrictionEncode({});
      setRestrict(isRestrict);
    }
    fetchData();
  }, []);

  const { currentPage, searchList } = state;

  const handleKeywordSearch = debounce((searchList) => {
    let variables = {
      currentPage: 1,
      searchList
    };
    setState(variables);
    refetch(variables);
  }, 250);

  const handleDelete = async (profileId, currentPage, userType) => {
    currentPage = await getCurrentPage({ results: getAllUsers?.results, page: currentPage });
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    let variables = { currentPage };
    const deleteUserResponse = await deleteUser(profileId, currentPage, userType);
    if (deleteUserResponse?.status === 200) {
      refetch(variables);
      setState(prev => ({ ...prev, currentPage }));
    }
  };

  const handleBanStatusChange = async (e, id, email, phoneDialCode, phoneNumber, userStatus, phoneCountryCode, currentPage) => {
    let data = {
      id: id,
      email: email,
      phoneDialCode: phoneDialCode,
      phoneNumber: phoneNumber,
      userStatus: userStatus,
      isBan: Number(e.target.value),
      phoneCountryCode: phoneCountryCode
    };
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    let variables = { currentPage };
    await editUser(data);
    refetch(variables);
  };

  const paginationData = (currentPage) => {
    let variables = { currentPage };
    setState(prev => ({ ...prev, currentPage }));
    refetch(variables);
  };

  const restrictExport = () => {
    showToaster({ messageId: 'disableDemo', toasterType: 'warning' })
  };

  return (
    <div className={'whiteDropdown'}>
      <div className={s.exportDisplay}>
        <div className={s.searchGroupContainer}>
          <div className={cx(s.searchInput, 'searchInputRTL')}>
            <FormControl
              type='text'
              placeholder={formatMessage(messages.searchOnly)}
              onChange={(e) => handleKeywordSearch(e.target && e.target.value)}
              className={bt.formControlInput}
            />
          </div>
        </div>
        <div className={cx(s.exportTextSection)}>
          {
            userDetails?.getAllUsers?.results && userDetails?.getAllUsers?.results?.length > 0 && (isRestrict ?
              <a
                href={`#`} onClick={() => restrictExport()}
                className={cx(s.exportTextContainer)}
              >
                <span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}>
                  <FormattedMessage {...messages.exportDataIntoCSV} />
                </span>
                <span className={cx(s.vtrTextBottom)}>
                  <ExportCsvIcon />
                </span>
              </a> : <a
                href={`/export-admin-data?type=users&keyword=${searchList ? searchList : ''}&toCurrency=${base}`}
                className={cx(s.exportTextContainer)}
              >
                <span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}>
                  <FormattedMessage {...messages.exportDataIntoCSV} />
                </span>
                <span className={cx(s.vtrTextBottom)}>
                  <ExportCsvIcon />
                </span>
              </a>)
          }
        </div>
      </div>
      {loading && <Loader type="circle" />}
      {!loading && (
        <div className='tableOuterContainer'>
          <Table className="tableContainer">
            <thead>
              <tr>
                <th scope="col"><FormattedMessage {...messages.id} /></th>
                <th scope="col"><FormattedMessage {...messages.firstName} /></th>
                <th scope="col"><FormattedMessage {...messages.lastName} /></th>
                <th scope="col" className='tableLargeHeading'><FormattedMessage {...messages.email} /></th>
                <th scope="col"><FormattedMessage {...messages.walletBalance} /></th>
                <th scope="col"><FormattedMessage {...messages.city} /></th>
                <th scope="col"><FormattedMessage {...messages.zipCode} /></th>
                <th scope="col"><FormattedMessage {...messages.country} /></th>
                <th scope="col" className='tableLargeHeading'><FormattedMessage {...messages.phoneNumber} /></th>
                <th scope="col" className='tableLargeHeading'><FormattedMessage {...messages.createdAt} /></th>
                <th scope="col"><FormattedMessage {...messages.banStatus} /></th>
                <th scope="col"><FormattedMessage {...messages.action} /></th>
                <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
              </tr>
            </thead>
            <tbody>
              {userDetails?.getAllUsers?.results && userDetails?.getAllUsers?.results?.length > 0 &&
                userDetails?.getAllUsers?.results?.map((item, index) => (
                  <tr key={index}>
                    <td data-label={formatMessage(messages.id)}>{item?.profile?.profileId}</td>
                    <td data-label={formatMessage(messages.firstName)}>{isRestrict ? censorWord(decode(item?.profile?.encryptFirstName)) : decode(item?.profile?.encryptFirstName)}</td>
                    <td data-label={formatMessage(messages.lastName)}>{isRestrict ? censorWord(decode(item?.profile?.encryptLastName)) : decode(item?.profile?.encryptLastName)}</td>
                    <td data-label={formatMessage(messages.email)} className='tableLargeHeading'>
                      {item?.encryptEmail && (isRestrict ? censorEmail(decode(item?.encryptEmail)) : decode(item?.encryptEmail))}
                    </td>
                    <td data-label={formatMessage(messages.walletBalance)}>
                      {item?.profile && (
                        <CurrencyConverter
                          from={item.profile.preferredCurrency}
                          amount={item.profile.walletBalance}
                        />
                      )}
                    </td>
                    <td data-label={formatMessage(messages.city)}>{item?.profile?.city ? item?.profile?.city : '-'}</td>
                    <td data-label={formatMessage(messages.zipCode)}>{item?.profile?.zipcode ? item?.profile?.zipcode : '-'}</td>
                    <td data-label={formatMessage(messages.country)}>{item?.profile?.country ? item?.profile?.country : '-'}</td>
                    <td data-label={formatMessage(messages.phoneNumber)} className='tableLargeHeading'>
                      {item && item?.phoneDialCode}{item?.encryptPhoneNumber && (isRestrict ? censorPhone(decode(item?.encryptPhoneNumber)) : decode(item?.encryptPhoneNumber))}
                    </td>
                    <td data-label={formatMessage(messages.createdAt)} className='tableLargeHeading'>
                      {item.createdAt
                        ? moment(Number(item.createdAt)).format('DD-MM-YYYY HH:mm:ss')
                        : '-'}
                    </td>
                    <td data-label={formatMessage(messages.banStatus)}>
                      <div>
                        <select
                          name="isBan"
                          className={bt.selectInput}
                          onChange={(e) => handleBanStatusChange(
                            e,
                            item.id,
                            decode(item.encryptEmail),
                            item.phoneDialCode,
                            decode(item.encryptPhoneNumber),
                            item.userStatus,
                            item.phoneCountryCode,
                            currentPage
                          )}
                          value={item.isBan}
                        >
                          <option value="0">{formatMessage(messages.permit)}</option>
                          <option value="1">{formatMessage(messages.ban)}</option>
                        </select>
                      </div>
                    </td>
                    <td data-label={formatMessage(messages.action)}>
                      <div>
                        <Link
                          to={'/siteadmin/users/' + item.profile.profileId}
                          className={s.noLink}
                        >
                          <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                          <span className={cx(s.vtrMiddle)}>
                            <FormattedMessage {...messages.editAction} />
                          </span>
                        </Link>
                      </div>
                    </td>
                    <td data-label={formatMessage(messages.deleteAction)}>
                      <div>
                        <Button
                          onClick={() => handleDelete(item.profile.profileId, currentPage, 1)}
                          className={s.iconBtn}
                        >
                          <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                          <span className={s.vtrMiddle}>
                            <FormattedMessage {...messages.deleteAction} />
                          </span>
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              }
              {(!loading && (userDetails && userDetails?.getAllUsers && userDetails?.getAllUsers?.results?.length === 0)) && (
                <tr>
                  <td colSpan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
      {userDetails?.getAllUsers?.results && userDetails?.getAllUsers?.results?.length > 0 && (
        <div className={cx(bt.space5, bt.spaceTop5)}>
          <CustomPagination
            total={userDetails.getAllUsers.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={paginationData}
            paginationLabel={formatMessage(messages.users)}
          />
        </div>
      )}
    </div>
  );
};

UsersList.propTypes = {
  userDetails: PropTypes.object,
  deleteUser: PropTypes.any,
  editUser: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func
  }),
  currency: PropTypes.string,
  base: PropTypes.string
};

const mapState = (state) => ({
  currency: state?.currency?.to,
  base: state?.currency?.base,
  base: state?.currency?.base
});

const mapDispatch = {
  deleteUser,
  editUser,
  demoRestriction,
  demoRestrictionEncode
};

export default compose(
  injectIntl,
  withStyles(bt, s),
  connect(mapState, mapDispatch)
)(UsersList);